const mutations = {

  initEnums(state, enums) {
    state.enums = enums;
  },

  //前端拿到后端返回的 loginToken, 存储在 localStroage/sessionStroage里
  setLoginToken(state, loginToken) {
    state.loginToken = loginToken;
  },

  //顶级节点
  setTopMenu(state,topMenu){
    state.topMenu = topMenu;
  },

  //模块对应子模块
  setModuleChild(state,moduleChildMap){
    state.moduleChildMap = moduleChildMap;
  },

  //末级模块对应的子功能
  setModuleFunc(state,moduleFuncMap){
    state.moduleFuncMap = moduleFuncMap;
  },

  //功能操作map
  setFuncOperMap(state,funcOperMap){
    state.funcOperMap = funcOperMap;
  },

  //第一个末级模块
  setFirstModule(state,firstModule){
    state.firstModule = firstModule;
  },

  //末级模块的第一个功能
  setFirstFunc(state, firstFunc) {
    state.firstFunc = firstFunc;
  },

  //登陆时重定向的功能Id
  setDefaultFuncId(state,defaultFuncId){
    state.defaultFuncId = defaultFuncId;
  },

  setSysUserId(state,sysUserId){
    state.sysUserId = sysUserId;
  },
}
export default mutations;
